import { gql } from '@apollo/client';
export const DEVICE_CONFIG_FIELDS = gql`
  fragment DeviceConfigFields on DeviceConfigDto {
    title
    favicon {
      name
      img
    }
  }
`;